<template>
  <div id="partner-objects-container">
    <BackComponent />

    <div id="partner-objects-header" v-if="results[Object.keys(results)[0]]">
      <p id="partner-name">
        {{ results[Object.keys(results)[0]].partnerName }}
      </p>
      <p id="partner-location">
        {{ results[Object.keys(results)[0]].location }},
        {{ results[Object.keys(results)[0]].countryName }}
      </p>
    </div>

    <div
      id="top-page-navigation"
      class="page-navigation-wrapper"
      v-if="displayPageNavigation"
    >
      <PagesComponent
        :pageInfo="pageInfo"
        :navigatePage="navigatePage"
        :navigatePageDirect="navigatePageDirect"
      ></PagesComponent>
    </div>

    <LoaderComponent v-if="!loaded" />
    <div v-else id="content-container">
      <div id="content-wrapper">
        <div id="partner-objects">
          <ObjectGrid
            :results="results"
            :lessThan974="lessThan974"
            :hover="hover"
            :show="show"
          ></ObjectGrid>
          <!--
          <div
            class="entry-container"
            v-for="(object, index) in objects"
            :key="object.imagePath"
            :class="`entry-${index + 1}`"
            v-on="
              lessThan974
                ? {}
                : {
                    mouseover: () => hoverHandler('over', index),
                    mouseleave: () => hoverHandler('leave', index),
                  }
            "
          >
            <div class="entry">
              <div class="entry-image-wrapper">
                <img class="entry-image" :src="object.imagePath" />
              </div>
              <div
                class="entry-details"
                v-show="
                  (!lessThan974 && hover && show === index) || lessThan974
                "
              >
                <router-link
                  class="entry-details-img-wrapper"
                  v-if="!lessThan974"
                  :to="{
                    name: 'database-object',
                    params: {
                      project: object.projectId,
                      country: object.countryId,
                      id: object.partnerId,
                      object: object.objectId,
                      language: object.languageId,
                    },
                  }"
                >
                  <img :src="object.imagePath" />
                </router-link>
                <div class="entry-details-wrapper">
                  <p class="entry-name" v-html="object.name"></p>
                  <p class="entry-date" v-html="object.objectDate"></p>
                  <p class="entry-partner">{{ object.partnerName }}</p>
                  <p class="entry-location">
                    {{ object.location }}, {{ object.countryName }}
                  </p>
                  <p class="entry-project">
                    for <span>{{ object.projectName }}</span>
                  </p>
                  <router-link
                    :to="{
                      name: 'database-object',
                      params: {
                        project: object.projectId,
                        country: object.countryId,
                        id: object.partnerId,
                        object: object.objectId,
                        language: object.languageId,
                      },
                    }"
                  >
                    <p class="entry-link">See Database Entry &gt;</p>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          -->
        </div>
        <div id="profile-link-container">
          <router-link
            id="profile-link"
            :to="{
              name: 'partner',
              params: {
                database: database,
                country: country,
                id: id,
                language: 'en',
              },
            }"
          >
            <font-awesome-icon :icon="['fas', 'share']" />Partner Profile
          </router-link>
        </div>
      </div>
    </div>

    <div
      id="bottom-page-navigation"
      class="page-navigation-wrapper"
      v-if="displayPageNavigation"
    >
      <PagesComponent
        :pageInfo="pageInfo"
        :navigatePage="navigatePage"
        :navigatePageDirect="navigatePageDirect"
      ></PagesComponent>
    </div>
    <div id="padding" v-else></div>
  </div>
</template>



<script>
import BackComponent from "./BackComponent.vue";
import LoaderComponent from "./LoaderComponent.vue";
import PagesComponent from "./PagesComponent.vue";
import ObjectGrid from "./ObjectGrid.vue";
import media from "../mixins/media.js";
import functions from "../mixins/functions.js";
import pageDisplay from "../mixins/pageDisplay.js";
// import characters from "../mixins/characters.js";
export default {
  name: "PartnerObjects",
  components: {
    BackComponent: BackComponent,
    LoaderComponent: LoaderComponent,
    PagesComponent: PagesComponent,
    ObjectGrid: ObjectGrid,
  },
  mixins: [media, functions, pageDisplay],
  data() {
    return {
      lessThan974: window.matchMedia("(max-width: 974px)").matches,
      loaded: false,
      database: this.$route.params.database,
      country: this.$route.params.country,
      id: this.$route.params.id,
      page: this.$route.params.page,
      results: {},
      // Path, current/last page, total pages, etc.
      pageInfo: {},
      // Links to first/last/next/previous pages
      pages: {},
      resultExist: false,
      displayPageNavigation: false,
      // Hide/show object popup
      hover: false,
      // Track which object popup to hide/show
      show: -1,
    };
  },
  watch: {
    // Run getPartnerObjects again on page change
    "$route.params.page"() {
      this.getPartnerObjects();
    },
  },
  methods: {
    getPartnerObjects: function () {
      this.database = this.$route.params.database;
      this.country = this.$route.params.country;
      this.id = this.$route.params.id;
      this.page = this.$route.params.page;
      let baseURL = `${process.env.VUE_APP_DXA_ENDPOINT}/`;
      let addURL, fullURL;
      // Partner objects URL differ based on associated project
      // if (this.database === "AWE") {
      //   addURL = `sh/objects?hash=${process.env.VUE_APP_API_HASH}&ip=${this.id}`;
      // } else {
      //   addURL = `mwnf3/objects?hash=${process.env.VUE_APP_API_HASH}&ic=${this.country}&ip=${this.id}`;
      // }
      addURL = `items?hash=${process.env.VUE_APP_API_HASH}&ic=${this.country}&ip=${this.id}`;
      if (this.page !== 1) {
        addURL = `${addURL}&page=${this.page}`;
      }
      fullURL = baseURL + addURL;
      return axios({ method: "GET", url: fullURL }).then(
        (result) => {
          // Sort by startDate key to order items chronologically
          this.results = this.sortChronological(result.data.items);
          // let sorted = Object.values(result.data.items).sort(function (a, b) {
          //   return a.startDate - b.startDate;
          // });
          // let dateTruncated = sorted;
          // for (let key in dateTruncated) {
          //   let date = dateTruncated[key].objectDate;
          //   if (this.charactersOver80(date)) {
          //     dateTruncated[key].objectDate = this.cutOff(date);
          //   }
          // }
          // this.results = dateTruncated;
          this.pageInfo = result.data.page;
          this.pages = result.data.links;
          this.setResultsExist();
          this.setDisplayPageNavigation();
          this.loaded = true;
        },
        (error) => {
          this.$router.replace({ name: "error" });
          console.error(error);
        }
      );
    },
    setResultsExist: function () {
      if (Object.entries(this.results).length === 0) {
        this.resultsExist = false;
      } else {
        this.resultsExist = true;
      }
    },
    // Navigate to appropriate page (first/last/next/previous)
    navigatePage: function (page) {
      let url;
      if (page === "first") {
        url = this.pages[0].href;
      } else if (page === "last") {
        url = this.pages[1].href;
      } else if (page === "next") {
        url = this.pages[2].href;
      } else if (page === "previous") {
        url = this.pages[3].href;
      }
      return axios({ method: "GET", url: url }).then(
        (result) => {
          this.results = result.data.items;
          this.pageInfo = result.data.page;
          this.pages = result.data.links;
          this.$router.push({
            name: "partner-objects",
            params: {
              database: this.database,
              country: this.country,
              id: this.id,
              page: this.pageInfo.currentPage,
            },
          });
        },
        (error) => {
          console.error(error);
        }
      );
    },
    // Navigate directly to a page by clicking a number
    navigatePageDirect: function (page) {
      this.$router.push({
        name: "partner-objects",
        params: {
          database: this.database,
          country: this.country,
          id: this.id,
          page: page,
        },
      });
    },
  },
  created() {
    this.getPartnerObjects();
  },
};
</script>



<style scoped lang="scss">
#partner-objects-container :deep(.fas) {
  font-size: 75%;
  padding-right: 4px;
}

#partner-objects-container {
  width: 100%;
  background-color: white;
}

#back {
  @include flex-center;
  justify-content: flex-start;
  height: 50px;
  padding: 30px 50px 0 50px;
}
#back .fas {
  font-size: 75%;
  padding-right: 4px;
}
#back button {
  @include button-styles;
  padding: 2px;
  font-weight: bold;
}

#partner-objects-header {
  padding: 10px 50px 0 50px;
}
#partner-name {
  font-size: 110%;
}
#partner-location {
  font-style: italic;
}

.loader-container {
  min-height: 400px;
}

#content-container {
  @include flex-center;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 0 50px;
}
#content-wrapper {
  @include flex-center;
  align-items: flex-start;
  width: 100%;
}
#partner-objects {
  width: 78%;
  padding: 30px 0;
}
#profile-link-container {
  width: 22%;
  padding: 30px 0 30px 25px;
}
#profile-link {
  @include link-styles;
  color: black;
}
#profile-link:hover {
  @include link-hover-styles;
}

#padding {
  margin-bottom: 75px;
}

/* IE-only */
@media only screen and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  #partner-objects {
    @include IE-grid-styles;
  }
}

@media only screen and (max-width: 1199px) {
  #partner-name {
    font-size: 105%;
  }
  #partner-objects {
    width: 80%;
  }
  #profile-link-container {
    width: 20%;
  }
}

@media only screen and (max-width: 974px) {
  #content-wrapper {
    flex-direction: column-reverse;
  }
  #profile-link-container {
    width: 100%;
    padding: 30px 0 0 0;
  }
  #partner-objects {
    width: 100%;
  }
}

@media only screen and (max-width: 599px) {
  #back {
    padding: 30px 30px 0 30px;
  }
  #partner-objects-header {
    padding: 10px 30px 0 30px;
  }
  #content-container {
    padding: 0 30px;
  }
}
</style>